var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Product-size"},[_vm._m(0),_c('div',{staticClass:"size-btns"},_vm._l((_vm.productSize),function(size,index){return _c('button',{key:index,staticClass:"btnSize",class:{ active: _vm.activeIndex === index ,
        disable: size.status ===0
      },attrs:{"disabled":size.status === 0},on:{"click":function($event){return _vm.selectSize(size, index)}}},[_vm._v(" "+_vm._s(size.description)+" ")])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-heading"},[_c('span',[_vm._v("Size:")])])
}]

export { render, staticRenderFns }